import React, { useEffect, useState } from 'react';
import { logApi } from '../api/client';
import LoadingSpinner from '../components/LoadingSpinner';

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [level, setLevel] = useState('');

  useEffect(() => {
    const params = level ? { level } : {};
    logApi.list(params).then(({ data }) => setLogs(data.results || data)).finally(() => setLoading(false));
  }, [level]);

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-gray-900">System-Logs</h1>
        <select value={level} onChange={e => setLevel(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none">
          <option value="">Alle Level</option>
          <option value="info">Info</option>
          <option value="warning">Warnung</option>
          <option value="error">Fehler</option>
        </select>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100">
        {loading ? <LoadingSpinner /> : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500 uppercase text-xs">
              <tr>
                {['Zeitpunkt', 'Level', 'Kunde', 'Mailkonto', 'Nachricht'].map(h => (
                  <th key={h} className="px-4 py-3 text-left font-medium">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {logs.map(l => (
                <tr key={l.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 text-xs text-gray-500 whitespace-nowrap">
                    {new Date(l.created_at).toLocaleString('de-DE')}
                  </td>
                  <td className="px-4 py-2">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                      l.level === 'error' ? 'bg-red-100 text-red-700' :
                      l.level === 'warning' ? 'bg-yellow-100 text-yellow-700' :
                      'bg-gray-100 text-gray-600'}`}>
                      {l.level}
                    </span>
                  </td>
                  <td className="px-4 py-2 text-xs text-gray-600">{l.customer}</td>
                  <td className="px-4 py-2 text-xs text-gray-500">{l.mail_account_email || '–'}</td>
                  <td className="px-4 py-2 text-xs">{l.message}</td>
                </tr>
              ))}
              {logs.length === 0 && (
                <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-400">Keine Logs vorhanden.</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
